import { Button, message } from 'antd';
import React, { type PropsWithChildren } from 'react';

import type Bundle from 'stores/Bundle';

interface Link {
  label: string;
  url: string;
}

const formatters = {
  'urls-only': (link: Link) => link.url,
  'labeled-urls': (link: Link) => `${link.label} - ${link.url}`,
} as const;

export type FormatName = keyof typeof formatters;
export type Formatter = (link: Link) => string;

function* getUrls(bundle: Bundle): Generator<Link> {
  for (const element of bundle.elements.all) {
    for (const build of element.data.builds) {
      if (build.buildType === 'dist') {
        for (const manifest of build.manifest) {
          // strictly speaking, this should be manifest.path === build.entry
          // but i need to check if this was papering over any inconsistent firestore data
          if (manifest.path.includes('index.html')) {
            yield {
              label: element.data.label,
              url: `${bundle.baseURL}/${manifest.storage}`,
            };
          }
        }
      }
    }
  }
}

async function doCopy(bundle: Bundle, formatter: Formatter) {
  const document = [...getUrls(bundle)].map(formatter).join('\n');

  try {
    await navigator.clipboard.writeText(document);
    void message.success('Ad links copied.');
  } catch (error) {
    void message.error('Failed to copy ad links: ' + error);
  }
}

export type CopyBundleUrlsButtonProps = PropsWithChildren<{
  bundle: Bundle;
  format: FormatName;
}>;

function CopyBundleUrlsButton({
  bundle,
  format,
  children,
}: CopyBundleUrlsButtonProps) {
  const formatter = formatters[format];
  return (
    <Button onClick={() => void doCopy(bundle, formatter)}>
      {children /*Copy URLs (Labeled)*/}
    </Button>
  );
}

export default CopyBundleUrlsButton;
